export default class TabbedList {
    constructor(element) {
        this.container = element;
        this.tabs = this.container.querySelectorAll(".c-tabbed-list__nav li");
        this.panels = this.container.querySelectorAll(".c-tabbed-list__panel");
        this.titleElement = this.container.querySelector("h2[data-title]");

        if (this.tabs.length && this.panels.length) {
            this.init();
        }
    }

    init() {
        this.panels.forEach(panel => {
            panel.style.opacity = "0";
            panel.style.visibility = "hidden";
        });

        this.tabs.forEach(tab => {
            tab.addEventListener("click", () => this.switchTab(tab));
        });

        // Activate the first tab
        const firstTab = this.tabs[0];
        if (firstTab) {
            this.switchTab(firstTab, true);
        }
    }

    switchTab(selectedTab, immediate = false) {
        const targetId = selectedTab.getAttribute("data-tab");
        const targetText = selectedTab.textContent.trim(); // Get tab text for the title update

        this.tabs.forEach(tab => tab.classList.remove("is-active"));
        this.panels.forEach(panel => {
            panel.style.opacity = "0";
            panel.style.visibility = "hidden";
            panel.classList.remove("is-active");
        });

        selectedTab.classList.add("is-active");
        const targetPanel = this.container.querySelector(`#${targetId}`);

        if (targetPanel) {
            targetPanel.classList.add("is-active");
            targetPanel.style.visibility = "visible";
            if (immediate) {
                // targetPanel.style.transition = "none"; // Skip animation on initial load
                targetPanel.style.opacity = "1";
            } else {
                setTimeout(() => {
                    targetPanel.style.opacity = "1";
                }, 10);
            }
        }

        // Update the title if it exists
        if (this.titleElement) {
            this.titleElement.dataset.title = `Showing ${targetText}`;
            const span = this.titleElement.querySelector("span");
            if (span) {
                span.textContent = `Showing ${targetText}`;
            }
        }
    }
};
